// Placeholder for arrows/autoplay enhancements.

document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".luxury-slider-wrapper").forEach(wrapper => {

        const slider = wrapper.querySelector(".luxury-slider");
        const prev = wrapper.querySelector(".luxury-prev");
        const next = wrapper.querySelector(".luxury-next");

        const scrollAmount = 320;

        next.addEventListener("click", () => {
            slider.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
        });

        prev.addEventListener("click", () => {
            slider.scrollBy({
                left: -scrollAmount,
                behavior: "smooth"
            });
        });

    });

});